// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"23c0321f","453":"54292a4b","732":"35ed01f5","977":"b584b783"}[chunkId] + ".chunk.js";
};